var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "50px",
    viewBox: "0 0 77 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-zero-state",
    transform: "translate(-502.000000, -92.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-contact-zero-state",
    transform: "translate(502.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 5.421687)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.2048193,42.1686747 C37.3493976,35.4216867 30.060241,30.8433735 21.686747,30.8433735 L21.686747,30.8433735 C13.313253,30.8433735 6.02409639,35.4216867 2.1686747,42.2289157 L2.22891566,44.0361446 L41.1445783,44.0361446 L41.2048193,42.1686747 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 21.686747,
    cy: 12.9518072,
    r: 10.5421687
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.686747,25.2409639 C14.8795181,25.2409639 9.3373494,19.6987952 9.3373494,12.8915663 C9.3373494,6.44578313 14.3975904,1.02409639 20.8433735,0.602409639 C21.8674699,0.542168675 22.7108434,1.26506024 22.7710843,2.28915663 C22.8313253,3.31325301 22.1084337,4.15662651 21.0843373,4.21686747 C16.5060241,4.51807229 12.9518072,8.31325301 12.9518072,12.8915663 C12.9518072,17.7108434 16.8674699,21.626506 21.686747,21.626506 C23.253012,21.626506 24.8192771,21.2048193 26.1445783,20.4216867 C26.9879518,19.939759 28.1325301,20.1807229 28.6144578,21.0240964 C29.0963855,21.8674699 28.8554217,23.0120482 28.0120482,23.4939759 C26.0843373,24.6385542 23.9156627,25.2409639 21.686747,25.2409639 Z",
    id: "Path",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1686747,43.9759036 C1.86746988,43.9759036 1.56626506,43.9156627 1.26506024,43.7349398 C0.421686747,43.253012 0.120481928,42.1686747 0.602409639,41.2650602 C3.73493976,35.7228916 9.03614458,31.5662651 15.1807229,29.8795181 C16.1445783,29.6385542 17.1686747,30.1807229 17.4096386,31.1445783 C17.6506024,32.1084337 17.1084337,33.1325301 16.1445783,33.373494 C10.9638554,34.8192771 6.44578313,38.373494 3.73493976,43.0722892 C3.43373494,43.6746988 2.8313253,43.9759036 2.1686747,43.9759036 Z",
    id: "Path",
    fill: "#B2C1DF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.542169, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.361445783,42.1686747 C4.21686747,35.4216867 11.5060241,30.8433735 19.8795181,30.8433735 L19.8795181,30.8433735 C28.253012,30.8433735 35.5421687,35.4216867 39.3975904,42.2289157 L39.3373494,44.0361446 L0.421686747,44.0361446 L0.361445783,42.1686747 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 19.8795181,
    cy: 12.9518072,
    r: 10.5421687
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8795181,25.2409639 C17.6506024,25.2409639 15.4819277,24.6385542 13.6144578,23.4939759 C12.7710843,23.0120482 12.4698795,21.8674699 13.0120482,21.0240964 C13.4939759,20.1807229 14.6385542,19.8795181 15.4819277,20.4216867 C16.8072289,21.2048193 18.373494,21.626506 19.939759,21.626506 C24.7590361,21.626506 28.6746988,17.7108434 28.6746988,12.8915663 C28.6746988,8.31325301 25.1204819,4.51807229 20.5421687,4.21686747 C19.5180723,4.15662651 18.7951807,3.31325301 18.8554217,2.28915663 C18.9156627,1.26506024 19.7590361,0.542168675 20.7831325,0.602409639 C27.2289157,1.02409639 32.2891566,6.44578313 32.2891566,12.8915663 C32.2289157,19.7590361 26.686747,25.2409639 19.8795181,25.2409639 Z",
    id: "Path",
    fill: "#B2C1DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3975904,43.9759036 C38.7951807,43.9759036 38.1325301,43.6746988 37.8313253,43.0722892 C35.1807229,38.373494 30.6626506,34.8192771 25.4216867,33.373494 C24.4578313,33.1325301 23.9156627,32.1084337 24.1566265,31.1445783 C24.3975904,30.1807229 25.4216867,29.6385542 26.3855422,29.8795181 C32.4698795,31.5662651 37.7710843,35.7228916 40.9638554,41.2650602 C41.4457831,42.1084337 41.1445783,43.253012 40.3012048,43.7349398 C40,43.9156627 39.6987952,43.9759036 39.3975904,43.9759036 Z",
    id: "Path",
    fill: "#B2C1DF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(13.855422, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0481928,47.3493976 C42.5903614,39.5783133 34.2771084,34.3373494 24.6987952,34.3373494 L24.6987952,34.3373494 C15.1204819,34.3373494 6.80722892,39.5783133 2.34939759,47.3493976 L2.40963855,49.3975904 L46.9879518,49.3975904 L47.0481928,47.3493976 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 24.6987952,
    cy: 13.8554217,
    r: 12.0481928
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6987952,27.7108434 C17.0481928,27.7108434 10.8433735,21.5060241 10.8433735,13.8554217 C10.8433735,6.20481928 17.0481928,0 24.6987952,0 C32.3493976,0 38.5542169,6.20481928 38.5542169,13.8554217 C38.5542169,21.5060241 32.3493976,27.7108434 24.6987952,27.7108434 Z M24.6987952,3.61445783 C19.0361446,3.61445783 14.4578313,8.19277108 14.4578313,13.8554217 C14.4578313,19.5180723 19.0361446,24.0963855 24.6987952,24.0963855 C30.3614458,24.0963855 34.939759,19.5180723 34.939759,13.8554217 C34.939759,8.19277108 30.3614458,3.61445783 24.6987952,3.61445783 Z",
    id: "Shape",
    fill: "#6F7FE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34939759,49.3975904 C2.04819277,49.3975904 1.74698795,49.3373494 1.44578313,49.1566265 C0.602409639,48.6746988 0.301204819,47.5903614 0.78313253,46.686747 C5.6626506,38.1325301 14.8192771,32.7710843 24.6987952,32.7710843 C34.5783133,32.7710843 43.7349398,38.1325301 48.6144578,46.686747 C49.0963855,47.5301205 48.7951807,48.6746988 47.9518072,49.1566265 C47.1084337,49.6385542 45.9638554,49.3373494 45.4819277,48.4939759 C41.2650602,41.0240964 33.313253,36.3855422 24.6987952,36.3855422 C16.1445783,36.3855422 8.19277108,41.0240964 3.91566265,48.4939759 C3.61445783,49.0963855 3.01204819,49.3975904 2.34939759,49.3975904 Z",
    id: "Path",
    fill: "#6F7FE2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactZeroState);
export default __webpack_public_path__ + "static/media/icon-contact-zero-state.0cfaf972e64b9e5bc1180ac40d64373a.svg";
export { ForwardRef as ReactComponent };